export const companyProfile = {
  'companyProfile.searchCandidates': 'Iskanje kandidatov',
  'companyProfile.goToDashboard': 'Namizje',
  'companyProfile.messageCenter': 'Sporočila',
}
